document.addEventListener('alpine:init', () => {
  Alpine.data('headroomMenu', () => ({
    visible: true,
    atTop: true,
    lastScroll: 0,

    init() {
      let ticking = false;
      const topOffset = 50;

      window.addEventListener('scroll', () => {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          this.atTop = scrollTop <= topOffset;

          this.visible = scrollTop <= 0 || scrollTop < this.lastScroll;

          this.lastScroll = Math.max(scrollTop, 0);

          ticking = false;
        });

      }, { passive: true });
    }
  }))
});